import { createContext, useContext, useState } from "react";

export interface ListViewControl {
  name: string;
  controls: ControlSet;
}

interface ControlGroupContext {
  controlGroups: ListViewControl[];
  setControlGroups: React.Dispatch<React.SetStateAction<ListViewControl[]>>;
  updateControlGroup: (id: string, updatedGroup: ListViewControl) => void;
  getControlByName: (name: string) => ListViewControl | undefined;
}
const defaultControlGroups: ListViewControl[] = [
  { name: "names", controls: { direction: "", filters: [] } },
  { name: "companies", controls: { direction: "", filters: [] } },
  { name: "status", controls: { direction: "", filters: [] } },
  { name: "created_at", controls: { direction: "", filters: [] } },
  { name: "signed_at", controls: { direction: "", filters: [] } },
];

const AppContext = createContext<ControlGroupContext | undefined>(undefined);

export const ControlGroupProvider: React.FC = ({ children }) => {
  const [controlGroups, setControlGroups] =
    useState<ListViewControl[]>(defaultControlGroups);

  const getControlByName = (name: string): ListViewControl | undefined => {
    return controlGroups.find((control) => control.name === name);
  };
  const updateControlGroup = (name: string, updatedGroup: ListViewControl) => {
    setControlGroups((prevGroups) =>
      prevGroups.map((group) => (group.name === name ? updatedGroup : group))
    );
  };

  return (
    <AppContext.Provider
      value={{
        controlGroups,
        setControlGroups,
        updateControlGroup,
        getControlByName,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useControlGroupContext = (): ControlGroupContext => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error("useAppContext must be used within an AppProvider");
  }
  return context;
};

export interface ControlSet
  extends Record<string, string | boolean | string[]> {
  direction: "asc" | "desc" | "";
  filters: string[];
}

export const defaultControlSet: ControlSet = {
  direction: "asc",
  filters: [],
};

export const defaultListViewControl: ListViewControl = {
  name: "",
  controls: defaultControlSet,
};
